<ng-container *ngIf="form$ | async as form">
  <ng-container *ngTemplateOutlet="actions"></ng-container>

  <cx-amend-order-items *ngIf="entries$ | async as entries" [entries]="entries">
  </cx-amend-order-items>

  <cx-form-errors
    aria-live="assertive"
    aria-atomic="true"
    [control]="form.get('entries')"
  ></cx-form-errors>

  <ng-container *ngTemplateOutlet="actions"></ng-container>

  <ng-template #actions>
    <cx-amend-order-actions
      *ngIf="orderCode"
      [orderCode]="orderCode"
      [amendOrderForm]="form"
      backRoute="orderDetails"
      forwardRoute="orderCancelConfirmation"
    ></cx-amend-order-actions>
  </ng-template>
</ng-container>
